/* global Modalytics */
import { initRecaptcha } from './initRecaptcha';

/**
 * Initializes reCAPTCHA for forms using the default quad and tracks the event in Heap.
 * @param {number} activeStepIndex - The index of the currently active step.
 * @returns {void}
 */
export function initRecaptchaDefaultQuad(activeStepIndex) {
	initRecaptcha();
	Modalytics.heap('track', ['Using Default Quad (Initialize reCaptcha)', {
		initializedStep: activeStepIndex
	}]);
}
